import { WorkingShiftDateRangeHourRange } from './working-shift-date-range-hour-range';

export class WorkingShiftDateRange {
  constructor(
    public hash?: string,
    public startDate?: number,
    public endDate?: number,
    public hourRanges?: WorkingShiftDateRangeHourRange[]
  ) { }

  clone() {
    return new WorkingShiftDateRange(
      this.hash,
      this.startDate,
      this.endDate,
      this.hourRanges
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/calendar/working-shift-date-range.ts